<template>
  <div class="row collapsible-body">
    <div class="row">
      <h4 class="header col s12 light">Gérer ma réservation</h4>
    </div>
    <ul class="collection" v-if="reservation">
      <li class="collection-item">
        N° de réservation : {{ reservation.code }}
      </li>
      <li class="collection-item">
        Port de départ : {{ reservation.departure.name }}
      </li>
      <li class="collection-item">
        Destination : {{ reservation.destination.name }}
      </li>

      <li class="collection-item">
        Date du départ :
        <br class="show-on-small" />
        {{ reservation.date_leave }}
        <span v-if="new_date_leave">
          <i class="material-icons">redo</i> {{ new_date_leave }}
        </span>
        <UpdateDate
          v-if="showButton(reservation.date_leave)"
          id="date"
          from="departure"
          to="destination"
          mindate=""
          v-model="reservation.date_leave"
        />
      </li>

      <li
        class="collection-item"
        v-bind:class="{ hidden: !reservation.date_return }"
        v-if="reservation.date_return"
      >
        Date de retour :
        <br class="show-on-small" />
        {{ reservation.date_return }}
        <span v-if="new_date_return">
          <i class="material-icons">redo</i> {{ new_date_return }}
        </span>
        <UpdateDate
          v-if="showButton(reservation.date_return)"
          id="datereturn"
          from="destination"
          to="departure"
          :mindate="new_date_leave || reservation.date_leave"
          v-model="reservation.date_return"
        />
      </li>
    </ul>

    <p class="center" v-if="reservation && passengers">
      <br />
      Cette réservation contient {{ passengers.length }} billets
      {{ reservation.date_return ? '"aller-retour"' : '"aller simple"' }}&nbsp;:
      <br />
    </p>

    <div class="row">
      <table>
        <thead>
          <tr>
            <th>Prénom</th>
            <th>Nom</th>
            <th class="hide-on-small-only">Billet</th>
            <th
              style="width: 45px"
              class="red lighten-5"
              v-if="passengers.length && passengers[0].new_price"
            >
              <div class="red-text">Ajustement</div>
            </th>
            <th style="width: 45px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-bind:key="passenger.code_reservation"
            v-for="passenger in passengers"
          >
            <td class="trunc">{{ passenger.firstname }}</td>
            <td class="trunc">{{ passenger.lastname }}</td>
            <td class="trunc hide-on-small-only">
              {{ passenger.pricename }} {{ passenger.amount }}€
            </td>
            <td
              class="center-align red lighten-5"
              style="width: 50px"
              v-if="passenger.new_price"
            >
              <!-- montant complémentaire à régler -->
              <span
                class="btn btn-small red"
                v-if="passenger.new_price.update_amount != 0"
              >
                +{{ passenger.new_price.update_amount }}&euro;
              </span>
              <span class="btn btn-small red" v-else> gratuit ! </span>
            </td>
            <td class="d-inline-block text-truncate" style="max-width: 150px;">Télécharger</td>
            <td style="width: 50px">
              <!-- ticket réservation aller/retour -->
              
              <button
                v-if="passenger.code_ticket_leave"
                v-on:click="download(passenger.url_ticket)"
                class="btn btn-small"
              >
                <i class="material-icons small">picture_as_pdf</i>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="passengers.length && passengers[0].new_price">
          <tr>
            <td colspan="2">
              <p class="red-text valign-wrapper" v-if="buy.sum == 0">
                Merci de confirmer maintenant votre demande de modification
                <i class="material-icons medium">arrow_forward</i>
              </p>
              <p class="red-text valign-wrapper" v-else>
                Afin de confirmer votre demande, merci de régler un complément
                de {{ buy.sum }}&euro;
                <i class="material-icons medium">arrow_forward</i>
              </p>
            </td>
            <td class="hide-on-small-only"></td>
            <td class="center-align red lighten-5">
              <div class="btn-floating pulse red" v-on:click="confirm()">
                <i class="material-icons" v-if="buy.sum == 0">check</i>
                <i class="material-icons" v-else>shopping_cart</i>
              </div>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import API from "../api.js";
// import qs from "qs";
import UpdateDate from "@/components/admin/UpdateDate.vue";

export default {
  components: {
    UpdateDate,
  },
  props: {},
  data() {
    return {
      reservation: {
        code: null,
        name: null,
        departure: { name: null },
        destination: { name: null },
        date_leave: null,
        date_return: null,
      },
      passengers: [],
      buy: {
        code: null,
        sum: null,
      },
      new_date_leave: null,
      new_date_return: null,
    };
  },
  mounted() {
    this.$root.$on("emit-reservation", (data) => {
      this.reservation = data.reservation;
      this.passengers = data.passengers;
      this.name = data.name;

      this.$root.$emit(
        // activate datepickers
        "emit-travel",
        this.reservation.departure.code,
        this.reservation.destination.code
      );
    });
    this.$root.$on("update-date", (data) => {
      if ("newdate" in data) {
        // update new_date_leave / new_date_return
        this["new_date_" + data.datetype] = data.newdate;
      }

      axios
        .get(API.updPrices, {
          params: {
            name: this.name,
            code: this.reservation.code,
            new_date_leave: this.new_date_leave
              ? this.new_date_leave
              : this.reservation.date_leave,
            new_date_return: this.new_date_return
              ? this.new_date_return
              : this.reservation.date_return,
          },
        })
        .then((resp) => {
          this.passengers.map((p) => {
            p.new_price = resp.data.passengers.find(
              (e) => e.code_reservation == p.code
            ) || { update_amount: 0 };
          });
          this.buy.sum = this.passengers.reduce(
            (acc, passenger) =>
              acc + parseInt(passenger.new_price.update_amount),
            0
          );

          this.$forceUpdate(); // changes are not detected as we change a sub-property (new_price) of data.passengers...
        });
    });
  },
  methods: {
    download(url) {
      window.open(url, "_blank");
    },
    confirm() {
      if (
        confirm("Êtes-vous sûr de vouloir enregistrer cette modification ?")
      ) {
        this.save();
      }
    },
    save() {
      axios
        .get(API.update, {
          params: {
            name: this.name,
            code: this.reservation.code,
            new_date_leave: this.new_date_leave
              ? this.new_date_leave
              : this.reservation.date_leave,
            new_date_return: this.new_date_return
              ? this.new_date_return
              : this.reservation.date_return,
          },
        })
        .then((res) => {
          if (!res.data.status || res.data.status !== "ok") {
            alert("problème avec le serveur :/");
            return false;
          }

          // this.buy.sum est une donnée générée à partir de l'API
          // update-prices.php. Ici, on peux se baser sur le retour 
          // du script de sauvegarde/paiement update.php, plus fiable.
          // if (this.buy.sum === 0) {
          if(res.data.payment.pbx_total === 0) {
            alert("La modification a bien été prise en compte !");
            // window.open(this.$root.$route.path);
            // console.log(this.$root.$route.path);
            // this.$router.push("/gerer");
            window.location.reload(); // reload the page
            return false;
          }

          // Now paying...

          // this.buy.code = res.data.update_code;
          this.buy.code = res.data.payment.pbx_cmd;


          for (let prop in res.data.payment) {
            let val = res.data.payment[prop];
            if (!val) continue;

            if (prop == "url") {
              document.querySelector("#banque").setAttribute("action", val);
            }

            if (prop.startsWith("pbx")) {
              document.querySelector(
                "#banque input[name=" + prop.toUpperCase() + "]"
              ).value = val;
            }
          }

          document.querySelector("#banque").submit();
        })
        .catch((err) => {
          console.log(err);
          alert(
            "Désolé, notre serveur a rencontré une petite erreur... " +
              "merci de réessayer un peu plus tard :)"
          );
          // this.$router.push('/');
        });
    },

    showButton(dateReservation){
      console.log(dateReservation);
      
      //console.log(this.value);

    if(dateReservation != null){
      const currentDate = new Date();
      const day = currentDate.getDate();
      const month = currentDate.getMonth() + 1; // Les mois commencent à partir de 0, donc ajoutez 1
      const year = currentDate.getFullYear();

      const formatted = `${month}/${day}/${year}`; 
      const formattedDate = new Date(formatted);

      const reservationDate = new Date(this.convertDateFrToEn(dateReservation));

      //console.log("test1 > " + this.mindate);
      //console.log("TEST DATE > " + reservationDate + " + DATE ACTUELLE >" + formattedDate);


      //console.log("TEST DATE > " + reservationDate + " + DATE ACTUELLE >" + formattedDate);

      if(reservationDate.getTime() < formattedDate.getTime()){
      return false;
      }else return true;

    }

    },

    convertDateFrToEn(dateFr) {
      if (typeof dateFr === 'string' || dateFr == "") {
      // Séparation de la date française en jour, mois et année
      const [day, month, year] = dateFr.split('/');
      const dateEn = `${month}/${day}/${year}`;
      return dateEn;
      } else {
      // Gérer le cas où dateFr n'est pas une chaîne de caractères
      console.error('dateFr n\'est pas une chaîne de caractères > ' + dateFr);
      return '';
      }

    },

  },
};
</script>

<style scoped>
input {
  max-width: calc(100% - 200px);
  margin: 0;
}
tfoot tr {
  border-bottom: none;
}
.hidden {
  display: none !important;
}
.show-on-small {
  display: none;
}
</style>